import audioManager from '../audioManager'

export const clicky = {
  mounted(el, binding, vnode) {
    // Add mousedown and mouseup event listeners for the active effect
    el.addEventListener('mousedown', () => {
      el.style.transform = 'translate3d(2px, 2px, 0)'
      el.style.filter = 'brightness(0.9)'
    })

    el.addEventListener('mouseup', () => {
      el.style.transform = ''
      el.style.filter = ''
    })

    // Also reset on mouse leave to prevent stuck state
    el.addEventListener('mouseleave', () => {
      el.style.transform = ''
      el.style.filter = ''
    })

    el.addEventListener('click', async (event) => {
      // Only play sound if the click wasn't already handled by OTButton
      if (!event._soundPlayed) {
        event._soundPlayed = true
        await audioManager.play('click')
      }
    })
  }
} 